import PropTypes from 'prop-types';
import React from 'react';

import httpClient from 'httpClient';

import AuthSearch from './AuthSearch';

function onGroupSearch(query, signal) {
  return Promise.all([
    httpClient.get('/api/groups', {signal, params: {identifier: query, exact: true}}),
    httpClient.get('/api/groups', {signal, params: {identifier: query}}),
    httpClient.get('/api/groups', {signal, params: {display_name: query}}),
    httpClient.get('/api/groups', {signal, params: {description: query}}),
  ]);
}

export default function GroupSearch({disabled, ...props}) {
  return (
    <AuthSearch
      itemKeyName="groupIdentifier"
      onSearch={onGroupSearch}
      itemRenderer={group => ({
        text: group.groupIdentifier,
        value: group.groupIdentifier,
        content: (
          <React.Fragment key={group.groupIdentifier}>
            <div className="text">{group.groupIdentifier}</div>
            <div className="description">{group.description}</div>
          </React.Fragment>
        ),
      })}
      noResultsMessage="No groups found"
      disabled={disabled}
      {...props}
    />
  );
}

GroupSearch.propTypes = {
  disabled: PropTypes.bool,
};

GroupSearch.defaultProps = {
  disabled: false,
};
